import {
  Package,
  Layers,
  Hammer,
  Globe,
  Box,
  Recycle,
  Truck,
  Flame,
} from "lucide-react";

export const BUSINESS = {
  name: "Pallet Works Logistic",
  phone: "(909) 955-7500",
  phoneHref: "tel:9099557500",
  email: "info@palletworkslogistic.com",
  emailHref: "mailto:info@palletworkslogistic.com",
  address1: "19084 Cajon Blvd",
  address2: "San Bernardino, CA 92407",
  cities: [
    "San Bernardino",
    "Fontana",
    "Ontario",
    "Chino",
    "Rialto",
    "Rancho Cucamonga",
  ],
};

export const IMG = {
  hero: "/images/home-hero-pallet-yard.png",
  truck: "/images/hero-truck-loaded-01.jpg",
  warehouse: "/images/hero-truck-loaded-02.jpg",
  forkliftOutdoor: "/images/company-trucks-yard.jpg",
  lumber: "/images/grade-a-pallet.webp",
  forklift: "https://images.unsplash.com/photo-1578575437130-527eed3abbec?q=80&w=1600&auto=format&fit=crop",
  palletStack: "https://images.unsplash.com/photo-1573209680076-bd7ec7007616?q=80&w=1600&auto=format&fit=crop",
  cleanPallets: "https://images.unsplash.com/photo-1594571194668-7112042d8f54?q=80&w=1600&auto=format&fit=crop",
  shelves: "https://images.unsplash.com/photo-1553413077-190dd305871c?q=80&w=1600&auto=format&fit=crop",
  aerialYard: "https://images.pexels.com/photos/9565565/pexels-photo-9565565.jpeg?auto=compress&cs=tinysrgb&w=1400",
  boxes: "https://images.pexels.com/photos/4483608/pexels-photo-4483608.jpeg?auto=compress&cs=tinysrgb&w=1400",
  warehouse2: "https://images.pexels.com/photos/4481259/pexels-photo-4481259.jpeg?auto=compress&cs=tinysrgb&w=1400",
  corrugated: "https://images.pexels.com/photos/1427541/pexels-photo-1427541.jpeg?auto=compress&cs=tinysrgb&w=1400",
  recycle: "https://images.pexels.com/photos/1267338/pexels-photo-1267338.jpeg?auto=compress&cs=tinysrgb&w=1400",
  skid: "https://images.pexels.com/photos/2226458/pexels-photo-2226458.jpeg?auto=compress&cs=tinysrgb&w=1400",
};

export const SERVICES = [
  { slug: "new-pallets", icon: Package, img: "/images/hero-truck-loaded-02.jpg" },
  { slug: "used-pallets", icon: Layers, img: "/images/products/used-pallets-stack.png" },
  { slug: "custom-pallets", icon: Hammer, img: "/images/grade-b-pallet-stack.png" },
  { slug: "euro-pallets", icon: Globe, img: "/images/regular-pallet-stack.png" },
  { slug: "plastic-pallets", icon: Box, img: "/images/plastic-pallets-stack.png" },
  { slug: "corrugated-pallets", icon: Layers, img: "/images/used-pallet-stack-02.png" },
  { slug: "pallet-recycling", icon: Recycle, img: "/images/warehouse-pallet-supply.png" },
  { slug: "pickup-delivery", icon: Truck, img: IMG.truck },
  { slug: "heat-treated-pallets", icon: Flame, img: "/images/heat-treated-stacks.png" },
];

export const PRODUCTS = [
  { slug: "new-pallets", img: "/images/products/new-pallets.jpg" },
  { slug: "used-pallets", img: "/images/products/used-pallets.jpg" },
  { slug: "custom-pallets", img: "/images/products/custom-pallets.webp" },
  { slug: "euro-pallets", img: IMG.cleanPallets },
  { slug: "plastic-pallets", img: "/images/products/plastic-pallets.jpg" },
  { slug: "corrugated-pallets", img: "/images/products/corrugated-pallets.jpg" },
  { slug: "cp1-cp3-pallets", img: "/images/products/cp1-cp3-pallets.jpg" },
  { slug: "heat-treated-pallets", img: "/images/products/block-pallet-48x40.webp" },
];
